module.exports = {
    getPlayerInfo: (p) => ({
        playername: p.playerIdentity.name,
        level: p.xp.level
    }),
    getLevel: ({newLevel}) => newLevel,
    lastTutorialLevel: 1,
    loginCmd: 'LOGIN_BASIC_DATA',
    levelUpCmd: 'LEVEL_UP'
}
